import {Modal} from '@enos/dpl';
import localeText from '@locale';
import './index.less';
import './mobile.less';

export default function({title, content, onOk, onCancel, okText = localeText('COMMON.BTN_I_SEE'), ...rest}) {
  Modal.error({
    className: 'error-modal middle-modal',
    title,
    content,
    onOk: () => {
      if (typeof onOk === 'function') {
        onOk();
      }
    },
    onCancel: () => {
      if (typeof onCancel === 'function') {
        onCancel();
      }
    },
    okText,
    ...rest
  });
  try {
    document.querySelector('.error-modal').style.zIndex = 9999;
  } catch (e) {
    console.log(e);
  }
}
